import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    apiListBatchRejectTypes,
    apiListCollectionPoints,
    apiListMaterials,
    apiListProjects,
    apiListUsers,
    apiListAffiliates,
    apiListStorages,
} from 'Services/AdminService'

export const getCollectionPoints = createAsyncThunk('admin/list/getCollectionPoints', async () => {
    const { data } = await apiListCollectionPoints()
    return data
})

export const getProjects = createAsyncThunk('admin/list/getProjects', async id => {
    const { data } = await apiListProjects(id)
    return data
})

export const getMaterials = createAsyncThunk('admin/list/getMaterials', async () => {
    const { data } = await apiListMaterials()
    return data
})

export const getAffiliates = createAsyncThunk('admin/list/getAffiliates', async () => {
    const { data } = await apiListAffiliates()
    return data
})

export const getStorages = createAsyncThunk('admin/list/getStorages', async () => {
    const { data } = await apiListStorages()
    return data
})

export const getBatchRejectTypes = createAsyncThunk('user/list/getBatchRejectTypes', async () => {
    const { data } = await apiListBatchRejectTypes()
    data.push({
        id: 'others',
        name: 'Others',
    })
    return data
})

export const getCollectionPointUsers = createAsyncThunk('admin/list/getCollectionPointUsers', async () => {
    const { data } = await apiListUsers()
    return data
})

export const listSlice = createSlice({
    name: 'admin/list',
    initialState: {
        collectionPoints: [],
        projects: [],
        materials: [],
        affiliates: [],
        storages: [],
        batchRejectTypes: [],
        collection_point_users: [],
    },
    extraReducers: builder => {
        builder
            .addCase(getCollectionPoints.fulfilled, (state, { payload }) => {
                state.collectionPoints = payload
            })
            .addCase(getCollectionPoints.rejected, state => {
                state.collectionPoints = []
            })

            .addCase(getProjects.fulfilled, (state, { payload }) => {
                state.projects = payload
            })
            .addCase(getProjects.rejected, state => {
                state.projects = []
            })

            .addCase(getMaterials.fulfilled, (state, { payload }) => {
                state.materials = payload
            })
            .addCase(getMaterials.rejected, state => {
                state.materials = []
            })

            .addCase(getAffiliates.fulfilled, (state, { payload }) => {
                state.affiliates = payload
            })
            .addCase(getAffiliates.rejected, state => {
                state.affiliates = []
            })

            .addCase(getStorages.fulfilled, (state, { payload }) => {
                state.storages = payload
            })
            .addCase(getStorages.rejected, state => {
                state.storages = []
            })

            .addCase(getBatchRejectTypes.fulfilled, (state, { payload }) => {
                state.batchRejectTypes = payload
            })
            .addCase(getBatchRejectTypes.rejected, state => {
                state.batchRejectTypes = []
            })

            .addCase(getCollectionPointUsers.fulfilled, (state, { payload }) => {
                state.collection_point_users = payload
            })
            .addCase(getCollectionPointUsers.rejected, state => {
                state.collection_point_users = []
            })
    },
})

export default listSlice.reducer
